/* eslint-disable no-unused-vars */
import React from 'react';
//import { Switch } from 'react-router-dom';
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  Outlet,
} from "react-router-dom";
import RouteWithLayout  from './components/RouteWithLayout'
import {PrivateRoute} from './views/authServices/privateRoute'
import ROUTE from './utils';
import useToken from './views/authServices/useToken';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';
import {SignIn as SignInView} from './views/SignIn/SignIn';
//import {LandingPage as LandingPageView} from './views/LandingPage/LandingPage';
import LandingPage from './views/LandingPage/LandingPage';
import {HomeList as HomeListView} from './views/Home/HomeList';
//import {KycForm as KycFormView} from './views/KycForm/KycForm';
import KycForm from './views/KycForm/KycForm';
//import {GetStarted as GetStartedViewPage} from './views/GetStarted/GetStarted';
import GetStarted from './views/GetStarted/GetStarted';
import SelfService from './views/pages/SelfService';
//import {NotFoundView as NotFoundViewPage} from './views/Errors/NotFoundView';
import NotFoundView from './views/Errors/NotFoundView';
import {ClientDataTable as ClientDataTableView} from './views/Home/components/ClientDataTable';
import {RejectedDataTable as RejectedDataTableView} from './views/Home/components/RejectedDataTable';
import {ApprovedDataTable as ApprovedDataTableView} from './views/Home/components/ApprovedDataTable';
import PrivacyPolicy from './views/pages/PrivacyPolicy';
import FeedbackChannel from './views/pages/FeedbackChannel';
import GuaranteeForm from './views/pages/GuaranteeForm';



const Routing = () => {
  
  // const { token, setToken } = useToken();
  // console.log('>>', token)
  // if (!token) {
  //   return ( <Switch>
  //   <RouteWithLayout
  //       component={SignInView}
  //       exact
  //       layout={MinimalLayout}
  //       path={ROUTE.login}
  //     />
  // </Switch>)}else{

  return (
<BrowserRouter>
    <Routes>
      <Route path={ROUTE.index} element={<LandingPage />} />
      <Route path={ROUTE.form} element={<KycForm />} />
      <Route path={ROUTE.getstarted} element={<GetStarted />} />
      <Route path={ROUTE.selfserve} element={<SelfService />} />
      <Route path={ROUTE.privacypolicy} element={<PrivacyPolicy />} />
      <Route path={ROUTE.guarantee} element={<GuaranteeForm />} />
      {/*<Route path={ROUTE.feedbackchannel} element={<FeedbackChannel />} />*/}     
      <Route path={ROUTE.all} element={<NotFoundView />} />
    </Routes>
</BrowserRouter>
    
  );

};

export default Routing;
